import React from 'react'
import { TemplateObject } from '../../Models/TemplateObject'

type Props = {
    inputProps: TemplateObject
    options?: { value: string; label: string; }[]
    changeHandler?: React.ChangeEventHandler<HTMLSelectElement>
}

const DropDown = ({ inputProps, options, changeHandler }: Props) => {
    return (
        <select
            id={inputProps.id}
            value={inputProps.selectedValue}
            name={inputProps.name}
            className={inputProps.className}
            style={inputProps.style}
            // placeholder={inputProps.placeholder}
            onChange={changeHandler}
        >
            {options?.map((options, key) => {
                return (
                    <>
                        <option value={options.value} key={'key' + inputProps.index + key}>
                            {options.label}
                        </option>
                    </>
                )
            })}
        </select>
    )
}

export default DropDown
